// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const JenkinsIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <g clipPath="url(#jenkins_svga)">
      <path
        fill="#D33833"
        fillRule="evenodd"
        d="M19.66 11.6a7.8 7.8 0 0 1-7.7 7.9 7.8 7.8 0 0 1-7.72-7.9 7.8 7.8 0 0 1 7.71-7.88 7.8 7.8 0 0 1 7.71 7.89"
        clipRule="evenodd"
      />
      <path
        fill="#EF3D3A"
        d="M4.55 13.56S4 5.33 11.58 5.1l-.53-.88L6.93 5.6 5.76 6.95 4.73 8.92l-.59 2.29.18 1.53"
      />
      <path
        fill="#231F20"
        d="M6.67 6.23a7.7 7.7 0 0 0-2.2 5.4c0 2.12.85 4.03 2.2 5.42a7.36 7.36 0 0 0 10.56 0 7.7 7.7 0 0 0 2.2-5.41c0-2.12-.84-4.03-2.2-5.41a7.36 7.36 0 0 0-10.56 0m-.34 11.15A8.2 8.2 0 0 1 4 11.64a8.2 8.2 0 0 1 2.33-5.75 7.84 7.84 0 0 1 11.25 0 8.2 8.2 0 0 1 2.32 5.75 8.2 8.2 0 0 1-2.32 5.74 7.84 7.84 0 0 1-11.25 0"
      />
      <path
        fill="#F0D6B7"
        fillRule="evenodd"
        d="m15.2 11.65-1.18.18-1.58.17-1.03.03-1-.03-.76-.23-.68-.74-.53-1.5-.12-.32-.7-.23-.41-.68-.3-.97.33-.85L8 6.2l.62.3.3.65.34-.06.12-.15-.12-.68-.03-.85.18-1.17v-.67l.53-.86.94-.68 1.64-.7 1.83.26 1.58 1.15.74 1.17.47.86.11 2.11-.35 1.82-.64 1.62-.62.85"
        clipRule="evenodd"
      />
      <path
        fill="#335061"
        fillRule="evenodd"
        d="m14.2 16.73-4.2.18v.7l.35 2.47-.18.2-2.93-1-.21-.34-.3-3.32-.67-2-.15-.47 2.35-1.62.74-.3.65.8.55.5.65.2.3.1.35 1.52.26.33.68-.24-.47.91 2.55 1.2z"
        clipRule="evenodd"
      />
      <path
        fill="#6D6B6D"
        fillRule="evenodd"
        d="M7.24 6.48 8 6.2l.62.3.3.65.34-.06.1-.36-.18-.67.17-1.62-.15-.88.53-.62 1.15-.9-.32-.45-1.62.8-.68.52-.38.83-.59.79-.17.94z"
        clipRule="evenodd"
      />
      <path
        fill="#DCD9D8"
        fillRule="evenodd"
        d="M8.44 3.72s.44-1.09 2.2-1.62.1-.38.1-.38l-1.92.73-.73.74-.32.59zM7.56 6.27s-.62-2.05 1.73-2.35l-.09-.35-1.61.38-.47 1.53.12 1z"
        clipRule="evenodd"
      />
      <path
        fill="#F7E4CD"
        fillRule="evenodd"
        d="m8.5 9 .38-.37s.18.02.2.23c.04.2.12 2.06 1.39 3.05.11.1-.94-.14-.94-.14l-.94-1.47M13.9 8.45s.07-.9.31-.82c.24.06.24.3.24.3s-.58.38-.54.52"
        clipRule="evenodd"
      />
      <path
        fill="#F7E4CD"
        d="M16.34 5.19s-.48.1-.52.53c-.05.42.52.08.61.05M12.79 5.22s-.65.08-.65.5c0 .4.74.38.94.2"
      />
      <path
        fill="#F7E4CD"
        fillRule="evenodd"
        d="M8.8 7.13s-1.12-.68-1.24-.03c-.12.64-.38 1.11.18 1.79l-.39-.12L7 7.86l-.12-.88.68-.7.76.05.44.35zM9.32 5.27s.5-2.58 3.03-3.08c2.08-.41 3.17.09 3.58.56 0 0-1.85-2.2-3.61-1.53s-3.06 1.91-3.03 2.7c.05 1.35.03 1.35.03 1.35M16.14 3.04s-.85-.03-.88.74c0 0 0 .11.06.23 0 0 .67-.76 1.08-.35"
        clipRule="evenodd"
      />
      <path
        fill="#F7E4CD"
        fillRule="evenodd"
        d="M12.4 4.1s-.14-1.18-1.14-.5c-.65.44-.59 1.06-.47 1.18s.09.35.18.19c.09-.17.06-.7.38-.84s.85-.31 1.06-.04"
        clipRule="evenodd"
      />
      <path
        fill="#49728B"
        fillRule="evenodd"
        d="m9.65 12.03-2.77 1.24s1.15 4.55.56 5.96l-.41-.15L7 17.35l-.76-3.3-.33-.9L8.8 11.2zM9.93 14.55l.4.48v1.76h-.48l-.06-1.38c0-.15.06-.67.06-.67M9.94 17.06l-1.32.06.38.26.94.15"
        clipRule="evenodd"
      />
      <path
        fill="#335061"
        fillRule="evenodd"
        d="m14.46 16.76 1.1-.03.26 2.7-1.12.15z"
        clipRule="evenodd"
      />
      <path
        fill="#335061"
        fillRule="evenodd"
        d="m14.76 16.76 1.64-.09s.68-1.7.68-1.79.59-2.47.59-2.47l-1.33-1.38-.26-.23-.7.7v2.74z"
        clipRule="evenodd"
      />
      <path
        fill="#49728B"
        fillRule="evenodd"
        d="m15.5 16.56-1.04.2.15.83c.38.17 1.03-.3 1.03-.3M15.52 11.42l2.06 1.52.06-.7-1.56-1.44z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m10.96 22.55-.6-2.47-.31-1.82-.05-1.35 2.75-.15h1.71l-.15 3.09.26 2.38-.03.44-2.23.17z"
        clipRule="evenodd"
      />
      <path
        fill="#DCD9D8"
        fillRule="evenodd"
        d="M14.08 16.73s-.14 3.06.3 5.23c0 0-.89.56-2.18.7l2.47-.08.3-.18-.36-4.81-.09-1.03"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m15.87 19.2 1.14-.32 2.18-.12.32-1-.59-1.73-.67-.09-.94.3-.9.43-.49-.08-.37.14"
        clipRule="evenodd"
      />
      <path
        fill="#DCD9D8"
        fillRule="evenodd"
        d="M15.84 18.61s.77-.35.89-.32l-.33-1.62.38-.14s.27 1.53.27 1.7l1.8.09s.34-.68.26-1.38l.32.94.03.53-.47.7-.53.12-.88-.03-.3-.38-1.02.15-.33.11"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="m14.69 16.53-.65-1.65-.67-.97s.14-.4.35-.4h.68l.64.23-.06 1.08z"
      />
      <path
        fill="#DCD9D8"
        fillRule="evenodd"
        d="M14.82 15.97s-.83-1.59-.83-1.82c0 0 .15-.35.36-.27l.64.33v-.56l-1-.2-.67.08 1.14 2.7.24.03"
        clipRule="evenodd"
      />
      <path fill="#fff" d="m11.22 12.1-.81-.1-.76-.23v.26l.37.41 1.17.53" />
      <path
        fill="#DCD9D8"
        fillRule="evenodd"
        d="M9.91 12.18s.91.38 1.2.3l.03.35-.82-.18-.5-.35z"
        clipRule="evenodd"
      />
      <path
        fill="#D33833"
        fillRule="evenodd"
        d="M15.86 13.6q-.75-.01-1.34-.18c.03-.17-.02-.32.02-.44.1-.08.29-.08.46-.1a1 1 0 0 0-.52-.05q-.02-.16-.08-.27c.28-.1.94-.76 1.31-.54.18.1.26.69.27.98.01.24-.02.48-.12.6"
        clipRule="evenodd"
      />
      <path
        stroke="#D33833"
        strokeWidth={0.18}
        d="M15.86 13.6q-.75-.01-1.34-.18c.03-.17-.02-.32.02-.44.1-.08.29-.08.46-.1a1 1 0 0 0-.52-.05q-.02-.16-.08-.27c.28-.1.94-.76 1.31-.54.18.1.26.69.27.98.01.24-.02.48-.12.6Z"
      />
      <path
        fill="#D33833"
        fillRule="evenodd"
        d="M13.48 12.79v.11c-.16.1-.41.1-.58.19q.37.02.62.15l-.01.29c-.29.2-.55.49-.89.67-.15.09-.71.3-.88.27-.1-.02-.1-.14-.14-.25-.08-.24-.27-.62-.29-.98-.02-.46-.07-1.22.43-1.13.4.08.85.26 1.16.43.19.1.3.22.58.25"
        clipRule="evenodd"
      />
      <path
        stroke="#D33833"
        strokeWidth={0.18}
        d="M13.48 12.79v.11c-.16.1-.41.1-.58.19q.37.02.62.15l-.01.29c-.29.2-.55.49-.89.67-.15.09-.71.3-.88.27-.1-.02-.1-.14-.14-.25-.08-.24-.27-.62-.29-.98-.02-.46-.07-1.22.43-1.13.4.08.85.26 1.16.43.19.1.3.22.58.25Z"
      />
      <path
        fill="#D33833"
        fillRule="evenodd"
        d="M13.76 13.33c-.04-.25-.1-.32-.07-.54.66-.44.78.76.07.54"
        clipRule="evenodd"
      />
      <path
        stroke="#D33833"
        strokeWidth={0.18}
        d="M13.76 13.33c-.04-.25-.1-.32-.07-.54.66-.44.78.76.07.54Z"
      />
      <path
        fill="#EF3D3A"
        fillRule="evenodd"
        d="M14.72 13.53s-.2-.3-.06-.38.3 0 .38-.15c.1-.14 0-.23.03-.4.03-.19.18-.21.33-.24.14-.03.55-.1.61.05l-.17-.52-.36-.12-1.11.64-.06.33v.64M11.63 14.5l-.11-1.37c-.06-.69.16-.57.76-.57.09 0 .56.1.59.18.16.32-.27.25.18.5.39.2 1.06-.13.9-.6-.08-.1-.44-.02-.57-.09l-.7-.36c-.29-.15-.96-.37-1.27-.16-.8.54.05 1.88.33 2.44"
        clipRule="evenodd"
      />
      <path
        fill="#231F20"
        fillRule="evenodd"
        d="M12.4 4.1c-.8-.2-1.2.33-1.43.87-.22-.06-.13-.35-.08-.5.14-.4.72-.92 1.2-.85.2.03.47.22.32.47M16.3 5h.05c.18.38.33.78.56 1.11-.15.36-1.15.67-1.14.03.22-.1.6-.02.79-.14-.12-.3-.28-.56-.25-1M12.82 5.01c.17.32.23.65.47.89.1.1.32.23.22.53a.7.7 0 0 1-.31.26c-.38.11-1.27.02-.97-.45.31.01.74.2.97-.03-.18-.29-.5-.86-.38-1.2M16.17 8.21c-.58.37-1.22.77-2.16.68a.64.64 0 0 1-.08-.82c.1.17.04.5.32.54.53.1 1.15-.32 1.54-.47.24-.4-.02-.55-.24-.8-.44-.54-1.03-1.2-1-1.99.17-.13.19.2.21.26.23.54.81 1.22 1.23 1.68.1.12.28.22.3.3.05.22-.15.48-.12.62M8.6 7.82c-.19-.1-.23-.55-.44-.57-.3-.01-.25.6-.25.95-.2-.2-.24-.77-.09-1.07-.17-.09-.25.1-.35.16.13-.9 1.32-.42 1.12.53M16.53 8.59c-.27.5-.64 1.07-1.43 1.08a2 2 0 0 1 0-.51c.6-.06.97-.36 1.43-.57M12.77 8.92c.5.26 1.42.29 2.1.27q.05.23.04.51c-.87.05-1.9-.17-2.14-.78M12.68 9.4c.34.88 1.53.78 2.54.75-.05.12-.14.25-.26.3-.32.13-1.21.23-1.66-.01-.28-.15-.46-.49-.62-.69-.07-.1-.44-.34 0-.34"
        clipRule="evenodd"
      />
      <path
        fill="#81B0C4"
        fillRule="evenodd"
        d="M16.12 14.2c-.4.7-.8 1.41-1.27 2.03.2-.6.29-1.6.32-2.35.42-.2.78.04.95.32"
        clipRule="evenodd"
      />
      <path
        fill="#231F20"
        fillRule="evenodd"
        d="M18.31 16.7c-.45.1-.77.53-1.22.5q.39-.49 1.22-.5M18.51 17.41c-.37.04-.8.1-1.18.07.18-.27.86-.18 1.18-.07M18.64 18.03c-.42 0-.94 0-1.33-.04.23-.25 1.06-.09 1.33.04"
        clipRule="evenodd"
      />
      <path
        fill="#DCD9D8"
        fillRule="evenodd"
        d="M15.34 19.7c.06.53.27 1.06.24 1.63-.23.08-.36.15-.67.15-.02-.49-.09-1.23-.07-1.7.15.01.38-.1.5-.07"
        clipRule="evenodd"
      />
      <path
        fill="#F0D6B7"
        fillRule="evenodd"
        d="M14.67 12q-.3.21-.59.45c-.44.02-.69-.03-1.01-.29q.02-.02.03-.03c.48.2 1.09-.1 1.57-.13"
        clipRule="evenodd"
      />
      <path
        fill="#81B0C4"
        fillRule="evenodd"
        d="M12.17 15.25c.13-.57.64-.87 1.1-1.18.49.61.78 1.4 1.1 2.16-.76-.23-1.54-.6-2.2-.98"
        clipRule="evenodd"
      />
      <path
        fill="#231F20"
        fillRule="evenodd"
        d="M14.84 19.78c-.02.47.05 1.21.07 1.7.3 0 .44-.07.67-.15.03-.57-.18-1.1-.24-1.62-.12-.04-.35.08-.5.07m-4.8-2.64c.2 1.87.5 3.44 1.04 5.1 1.2.37 2.64.4 3.7.07-.2-.94-.1-2.07-.22-3.07-.09-.75-.04-1.5-.16-2.27a13 13 0 0 0-4.36.17m4.66-.16q0 1.2.1 2.4c.31-.05.52-.08.8-.14-.09-.77-.08-1.65-.27-2.33q-.3-.02-.63.07m1.57-.13c-.15-.03-.32 0-.46 0 .07.66.23 1.38.28 2.07.22 0 .34-.1.52-.13.01-.6-.05-1.44-.34-1.94m2.37 2.17c.46-.12.75-.68.62-1.25-.09-.4-.24-1.12-.4-1.37-.13-.18-.46-.42-.72-.26-.43.28-1.18.36-1.49.69.16.52.2 1.23.27 1.9.53.02 1.19-.16 1.63.03-.3.1-.7.1-.98.25.22.1.73.09 1.07 0m-4.27-2.8c-.32-.75-.61-1.54-1.1-2.15-.46.31-.97.6-1.1 1.18.66.37 1.44.75 2.2.98m.8-2.34a10 10 0 0 1-.32 2.34c.48-.6.87-1.32 1.27-2.02-.17-.28-.53-.52-.95-.32m-.9-.32c-.19-.02-.34.2-.58.1l-.16.2c.53.63.76 1.52 1.17 2.26.22-.7.2-1.5.24-2.27-.3.02-.46-.27-.67-.3m-.58-.77c-.02.22.03.3.07.54.71.22.59-.98-.07-.54m-.8-.25c-.3-.17-.76-.35-1.15-.43-.5-.1-.45.67-.43 1.13.02.36.2.74.29.98.04.1.04.23.14.25.17.04.73-.18.88-.27.34-.18.6-.48.89-.67v-.29a2 2 0 0 0-.61-.15c.17-.09.42-.09.57-.19v-.11c-.28-.03-.38-.15-.57-.25M9.98 12c-.25.26.71.61 1.02.63 0-.16.1-.31.08-.43-.37-.07-.85-.02-1.1-.2m3.13.13q-.01.01-.03.03c.32.26.57.31 1.01.29q.29-.24.59-.45c-.48.04-1.09.34-1.57.13m2.88.87c-.01-.29-.09-.88-.27-.98-.37-.22-1.03.44-1.31.54q.06.1.08.27a1 1 0 0 1 .52.05c-.17.02-.35.02-.46.1-.04.12 0 .27-.02.44q.6.16 1.34.18c.1-.12.13-.36.12-.6m-6.44-.75c-.08-.05-.62-.76-.7-.73-.97.39-1.88 1.06-2.7 1.69.78 1.67 1.1 3.72 1.15 5.69.9.42 1.67 1.02 2.89 1.08-.14-.99-.27-1.87-.35-2.8-.3-.14-.74 0-1.03-.05 0-.34.44-.15.47-.38.03-.17-.24-.19-.15-.46.22.08.34.26.58.33.21-.48 0-1.32.03-1.72 0-.07.03-.4.2-.35.15.05 0 .9 0 1.28.02.34-.03.68.1.9 1.18-.17 2.36-.27 3.63-.3-.28-.12-.6-.24-.97-.44-.2-.11-.82-.34-.87-.53-.1-.3.23-.46.29-.71-.6.32-.7-.3-.85-.76q-.18-.59-.23-.94c-.5-.24-1.05-.49-1.49-.8m5.92-.64c.82-.4.97 1.47.65 2.08.05.18.22.25.28.4-.45.82-.95 1.58-1.42 2.39.35-.22.84-.04 1.25-.2.14-.06.25-.4.36-.67.31-.75.64-1.7.78-2.4.03-.17.12-.52.1-.67-.03-.26-.38-.45-.56-.61-.33-.3-.54-.56-.88-.83-.14.2-.44.34-.56.5M7.68 4.38c-.39.43-.3 1.23-.26 1.8.7-.44 1.63.03 1.62.79.34-.01.13-.42.07-.69-.2-.86.33-1.8.02-2.58q-.91.08-1.45.68m2.78-2.48c-.88.25-2 .9-2.37 1.68.28-.04.47-.18.75-.2.1 0 .24.05.36.02.24-.06.44-.6.62-.8s.39-.28.53-.45c.1-.05.23-.04.24-.18q-.06-.08-.13-.07m4.57.24c-.91-.52-2.45-.9-3.42-.42-.79.4-1.85 1.04-2.2 1.86.33.78-.1 1.5-.13 2.31-.02.43.2.8.21 1.26-.11.2-.46.22-.7.2-.1-.4-.23-.87-.66-.91-.6-.07-1.03.43-1.06.94C7.04 8 7.54 9 8.25 8.93c.27-.03.34-.3.63-.3.17.33-.25.43-.29.66l.06.4c.13.53.42 1.22.7 1.62.36.52 1.06.6 1.82.65.14-.3.63-.27.96-.2a3 3 0 0 1-1.05-.85c-.35-.38-.7-.8-.71-1.29.65.9 1.19 1.7 2.37 2.1.9.3 1.94-.15 2.63-.63.29-.2.46-.52.66-.81a7 7 0 0 0 1.04-4.16c-.04-.63-.04-1.25-.24-1.67-.22-.44-.96-.83-1.4-.43-.08-.43.36-.7.88-.54-.37-.47-.75-1.05-1.28-1.34m1.7 14.06c.71-.35 2.05-.95 2.5 0 .16.36.35.95.44 1.31.12.52-.13 1.6-.66 1.77q-.72.21-1.57.03a1 1 0 0 1-.2-.25q-.6-.05-1.08.18c.03.3-.17.35-.36.4-.14.56.28 1.28.18 1.78-.07.36-.51.42-.84.48q0 .3.04.54c-.08.27-.4.43-.72.46a9 9 0 0 1-3.61-.17c-.28-.69-.5-1.52-.73-2.3-.97.1-1.76-.41-2.5-.76-.26-.12-.61-.18-.7-.39-.1-.2-.06-.57-.09-.93-.05-.92-.1-1.8-.35-2.73-.1-.42-.3-.8-.43-1.2-.12-.38-.33-.84-.39-1.21-.08-.56.44-.59.78-.83.51-.37.92-.58 1.48-.91.16-.1.66-.35.72-.47.11-.23-.2-.55-.28-.73a2 2 0 0 1-.21-.8 1.6 1.6 0 0 1-1.04-.68c-.36-.52-.6-1.48-.3-2.22.03-.05.15-.17.17-.25.03-.18-.07-.41-.08-.6-.03-.95.17-1.77.8-2.06.27-1.04 1.2-1.38 2.08-1.9.33-.19.69-.31 1.06-.45 1.34-.5 3.4-.4 4.51.44a6 6 0 0 1 1.5 1.66c.7 1.44.66 3.84.16 5.6-.07.23-.16.58-.3.86-.1.2-.39.59-.35.76.03.18.67.67.8.8.25.23.71.55.75.84.04.32-.14.75-.23 1.06q-.44 1.52-.95 2.87"
        clipRule="evenodd"
      />
      <path
        fill="#F7E4CD"
        fillRule="evenodd"
        d="M11.98 9.14c.03-.05.25-.13.54.01 0 0-.35.06-.32.65l-.15-.03s-.15-.53-.07-.63"
        clipRule="evenodd"
      />
      <path
        fill="#1D1919"
        fillRule="evenodd"
        d="M14.55 14.2a.16.16 0 1 1-.32 0 .16.16 0 0 1 .32 0M14.71 14.94a.16.16 0 1 1-.32 0 .16.16 0 0 1 .32 0"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="jenkins_svga">
        <path fill="#fff" d="M4 1h15.94v22H4z" />
      </clipPath>
    </defs>
  </svg>,
  "Jenkins",
);
export default JenkinsIcon;
